import {
  Button,
  Drawer,
  Grid,
  IconButton,
  TextField,
  Typography,
  makeStyles,
  Tabs,
  Tab,
  Box,
  FormControlLabel,
  RadioGroup,
  Radio,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import { useState } from 'react';
import { handleReturnValue, handleReturnValueSigEmp } from '../../../common/functions/returnValue';
import { customtheme } from '../../../app/theme/theme';
import PurchaseOrderEmitItemDialog from '../PurchaseOrderEmitItemDialog';
import { mapperToPurchaseOrderItem, mapperToPurchaseOrderParcela } from '../../../app/mappers/purchase-order/purchase-order.mapper';
import PurchaseOrderEmitParcelaDialog from '../PurchaseOrderEmitParcelaDialog';
import { formatedYearDate } from '../../../common/functions/getDate';

/* ------------------------- estilos ------------------------- */
const useStyles = makeStyles(theme => ({
  drawer: { width: 500 },
  drawerHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  /* nova faixa para as tabs */
  tabsBar: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  tabRoot: {
    minWidth: 0,
    paddingLeft: 8,
    paddingRight: 8,
    },
  drawerContent: {
    overflowY: 'auto',
    padding: theme.spacing(2),
    height: '100%',
  },
  drawerFooterBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
  },
  drawerFooter: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    background: customtheme.gray[200],
  },
  textField: {
    minWidth: 140,
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .MuiInputBase-input': { color: customtheme.black },
    '& .MuiInput-underline:hover:before': {
      borderBottomColor: customtheme.blue[500],
    },
  },
  searchIcon: {
    marginRight: theme.spacing(1),
    color: customtheme.blue[500],
  },
  backgroundColor: {
    background: customtheme.blue[500],
    color: customtheme.white,
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
  backBackgroundColor: {
    background: customtheme.gray[200],
    color: customtheme.blue[500],
    '&:hover': { background: customtheme.blue[50], color: customtheme.blue[500] },
  },
  title: {
    color: customtheme.blue[500],
  },
}));

/* ----------------------- TabPanel helper ----------------------- */
interface TabPanelProps {
  value: number;
  index: number;
  children?: React.ReactNode;
}
const TabPanel = ({ value, index, children }: TabPanelProps) => (
  <div role="tabpanel" hidden={value !== index} style={{ flex: 1 }}>
    {value === index && <Box>{children}</Box>}
  </div>
);

/* ------------------- Props e componente ------------------- */
interface DialogSearchData {
  id: string;
  title: string;
  key: string;
  keySub: string;
  subKeySub?: string;
  isPrevSearch?: boolean;
  prevSearch?: any;
  prevDataSearch: any;
  hasButtonCreate: boolean;
}
interface PurchaseOrderEmitDrawerProps {
  handleCloseDrawer: () => void;
  handleOpenDialogSearch: (data: DialogSearchData) => void;
  handleCheckFields: () => void;
  handleCloseSnackbar: (e?: React.SyntheticEvent, reason?: string) => void;
  isDrawerOpen: { open: boolean; btnTitle: string; btnType: string };
  fields: any[];
  setFields: (array: any[]) => void;
  checkPrevCompanyValue: { exists: boolean, value: any };
  checkPrevBranchValue: { exists: boolean, value: any };
  setIsSnackbar: (snackBarProps: {open: boolean, message: string, title: string}) => void;
}

export default function PurchaseOrderEmitDrawer({
  isDrawerOpen, fields, checkPrevCompanyValue, checkPrevBranchValue, setIsSnackbar,
  setFields, handleCheckFields, handleCloseDrawer, handleOpenDialogSearch
}: PurchaseOrderEmitDrawerProps) {
  const classes = useStyles();
  const [tab, setTab] = useState(0);
  const [isPagamentoVista, setIsPagamentoVista] = useState(false);

  // Drawer itens
  const fieldsInit = mapperToPurchaseOrderItem({})
  const [openItemDrawer, setOpenItemDrawer] = useState({ open: false, item: fieldsInit, index: -1});
  const handleCloseItemDrawer = () => setOpenItemDrawer({ open: false, item: fieldsInit, index: -1});
  const handleOpenItemDrawer = (item: any, index: number) => setOpenItemDrawer({ open: true, item, index: index});

  const fieldsInitParcela = mapperToPurchaseOrderParcela({})
  const [openParcelaDrawer, setOpenParcelaDrawer] = useState({ open: false, item: fieldsInitParcela, index: -1});
  const handleCloseParcelaDrawer = () => setOpenParcelaDrawer({ open: false, item: fieldsInitParcela, index: -1});
  const handleOpenParcelaDrawer = (item: any, index: number) => setOpenParcelaDrawer({ open: true, item, index: index});

  const setLowerKeys = (array: Array<any>) => {
    const arrChecked = !Array.isArray(array) ? [array] : array;
    return arrChecked.map(r =>
      Object.entries(r).reduce((acc: any, [key, value]: any) => {
        acc[key.toLowerCase()] = value;
        return acc;
      }, {}),
    );
  };

  const handleTabChange = (_: unknown, newValue: number) => setTab(newValue);

  const handleCheckFieldsItem = (itemFields: any) => {
    const requireds = itemFields.filter((field:any) => field.required)
    if(requireds.length !== requireds.filter((required:any) => required.value).length) {
      setIsSnackbar({open:true, message: 'Por favor, adicione os campos obrigatórios!', title: 'error'})
    } else { 
      const upd = [...fields];
      const itensForm = upd[upd.findIndex(f => f.id === 'itens')]
      const values = [...itensForm.value];
      if (openItemDrawer.index === -1) {
        values.push(itemFields);
      } else {
        values[openItemDrawer.index] = itemFields;
      }
      itensForm.value = values
      setFields(upd);
      handleCloseItemDrawer();
    }
  }

  const handleCheckFieldsParcela = (itemFields: any) => {
    const requireds = itemFields.filter((field: any) => field.required);

    if (requireds.length !== requireds.filter((r: any) => r.value).length) {
      setIsSnackbar({
        open: true,
        message: "Por favor, adicione os campos obrigatórios!",
        title: "error"
      });
      return;
    }

    const upd = [...fields];
    const itensForm = upd[upd.findIndex((f) => f.id === "parcelas")];
    const values = [...itensForm.value];
    const originalValues = JSON.parse(JSON.stringify(values));

    // ORDENAR PELAS PARCELAS
    const sortedValues = [...values].sort((a, b) => {
      const seqA = a.find((v: any) => v.id === "seqpar")?.value?.seqpar;
      const seqB = b.find((v: any) => v.id === "seqpar")?.value?.seqpar;
      return Number(seqA) - Number(seqB);
    });

    // Nº da parcela que estamos mexendo
    const seqparItem = itemFields.find((v: any) => v.id === "seqpar")?.value?.seqpar;

    // Data sendo inserida/editada
    const newDateStr = itemFields.find((v: any) => v.id === "vctpar")?.value?.vctpar;
    const newDate = new Date(newDateStr);

    if (!isNaN(newDate.getTime())) {

      // É uma edição? 
      const pos = sortedValues.findIndex(
        (v: any) =>
          v.find((x: any) => x.id === "seqpar")?.value?.seqpar === seqparItem
      );

      if (pos !== -1) {
        const currentItem = originalValues.find(
          (v: any) =>
            v.find((x: any) => x.id === "seqpar")?.value?.seqpar === seqparItem
        );
        const currentDateStr =
          currentItem.find((v: any) => v.id === "vctpar")?.value?.vctpar;
        const currentDate = new Date(currentDateStr);

        // Permitir editar para a mesma data
        if (newDate.toISOString().split('T')[0] !== currentDate.toISOString().split('T')[0]) {
          // Buscar a parcela anterior (se houver)
          if (pos > 0) {
            const prevItem = sortedValues[pos - 1];
            const prevDateStr =
              prevItem.find((v: any) => v.id === "vctpar")?.value?.vctpar;

            const prevDate = new Date(prevDateStr);

            // Validar contra a data anterior somente
            if (newDate <= prevDate) {
              setIsSnackbar({
                open: true,
                message: "A data da parcela não pode ser menor que a anterior!",
                title: "error"
              });
              return;
            }
          }
        }
      } else {
        if (sortedValues.length > 0) {
          const lastItem = sortedValues[sortedValues.length - 1];
          const lastDateStr =
            lastItem.find((v: any) => v.id === "vctpar")?.value?.vctpar;
          const lastDate = new Date(lastDateStr);

          if (newDate <= lastDate) {
            setIsSnackbar({
              open: true,
              message:
                "Não pode adicionar vencimento anterior à última parcela existente!",
              title: "error"
            });
            return;
          }
        }
      }
    }

    const pos = values.findIndex(
      (val) =>
        val.filter((v: any) => v.id === "seqpar")[0].value.seqpar ===
        openParcelaDrawer.index
    );

    if (pos === -1) {
      values.push(itemFields);
    } else {
      values[pos] = itemFields;
    }

    itensForm.value = values;
    handleCloseParcelaDrawer();
  };
  
  const handleCheckFieldsParcelaEmpty = () => {
    const upd = [...fields];
    const itensForm = upd[upd.findIndex(f => f.id === 'parcelas')]
    itensForm.value = [];
    setFields(upd);
  }

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen.open}
      onClose={handleCloseDrawer}
      classes={{ paper: classes.drawer }}
    >
      {/* -------- HEADER -------- */}
      <div className={classes.drawerHeader}>
        <Typography variant="h6">Adicionar Item</Typography>
      </div>


      {/* -------- CONTENT -------- */}
      <div className={classes.drawerContent}>
      <Tabs
        value={tab}
        onChange={handleTabChange}
        indicatorColor="primary"
        textColor="primary"
        variant="fullWidth"
        className={classes.tabsBar}
      >
        <Tab label="Dados Gerais"classes={{ root: classes.tabRoot }}/>
        <Tab label="Produtos / Serviços"classes={{ root: classes.tabRoot }} />
        <Tab label="Parcelas"classes={{ root: classes.tabRoot }} />
        <Tab label="Anexos" classes={{ root: classes.tabRoot }}/>
      </Tabs>
      {/* -------- TABS -------- */}
      
        {/* ------------ DESCRIÇÃO ------------- */}
        <TabPanel value={tab} index={0}>
          <Grid container spacing={2} style={{ padding: 8 }}>
            <TextField
              label="Empresa"
              onClick={() => handleOpenDialogSearch({
              id: 'dados',
              title: 'Empresa',
              keySub: 'sigemp',
              key: 'codemp',
              prevDataSearch: {},
              hasButtonCreate: false,
              })}
              value={
                  handleReturnValueSigEmp('dados', fields)                 
              }
              fullWidth
              className={classes.textField}
              InputProps={{
                endAdornment: (
                    <IconButton
                    className={classes.searchIcon}
                    onClick={() => handleOpenDialogSearch({
                        id: 'dados',
                        title: 'Empresa',
                        keySub: 'sigemp',
                        key: 'codemp',
                        prevDataSearch: {},
                        hasButtonCreate: false,
                        })}>
                    <SearchIcon />
                    </IconButton>
                ),
              }}
            />
            <TextField
              label="Filial"
              onClick={
              () => checkPrevCompanyValue.exists ? 
                  handleOpenDialogSearch({
                  id: 'filiais', 
                  title: 'Filial', 
                  keySub: 'nomfil', 
                  key: 'codfil',
                  isPrevSearch: true,
                  prevSearch: setLowerKeys(fields.filter((field) => field.id === 'dados')[0].value?.filiais || []),
                  prevDataSearch: {},
                  hasButtonCreate: false,
                  }) 
                  : () => {}
              }
              value={
                  checkPrevCompanyValue.exists ?
                      handleReturnValue('filiais', fields)
                  : 'Selecione uma empresa primeiro'
              }
              fullWidth
              className={classes.textField}
              disabled={
                checkPrevCompanyValue.exists ? false : true
              }
              InputProps={{
              endAdornment: (
                  <IconButton
                  className={classes.searchIcon}
                  onClick={() => checkPrevCompanyValue.exists ? 
                      handleOpenDialogSearch({
                      id: 'filiais', 
                      title: 'Filial', 
                      keySub: 'nomfil', 
                      key: 'codfil',
                      isPrevSearch: true,
                      prevSearch: setLowerKeys(fields.filter((field) => field.id === 'dados')[0].value?.filiais || []),
                      prevDataSearch: {},
                      hasButtonCreate: false,
                      }) : 
                      () => {}
                  }
                  disabled={
                    checkPrevCompanyValue.exists ? false : true
                  }
                  >
                  <SearchIcon />
                  </IconButton>
                ),
              }}
            />
            <TextField
              label="Data Emissao"
              type="date"
              value={fields.find(f => f.id === 'datemi')?.value?.datemi}
              onChange={e => {
                const upd = [...fields];
                upd[upd.findIndex(f => f.id === 'datemi')].value = { datemi: e.target.value };
                setFields(upd);
              }}
              className={classes.textField}
              InputLabelProps={{ shrink: true }}
            />
            
            <TextField
                label="Transação"
                onClick={
                () => checkPrevCompanyValue.exists ? 
                    handleOpenDialogSearch({
                    id: 'transacao', 
                    title: 'Transação', 
                    keySub: 'destns', 
                    key: 'codtns',
                    prevDataSearch: { lismod: 'COO' },
                    hasButtonCreate: false,
                    }) 
                    : () => {}
                }
                value={
                    checkPrevCompanyValue.exists ?
                        handleReturnValue('transacao', fields)
                    : 'Selecione uma empresa primeiro'
                }
                fullWidth
                className={classes.textField}
                disabled={
                  checkPrevCompanyValue.exists ? false : true
                }
                InputProps={{
                endAdornment: (
                    <IconButton
                    className={classes.searchIcon}
                    onClick={() => checkPrevCompanyValue.exists ? 
                        handleOpenDialogSearch({
                        id: 'transacao', 
                        title: 'Transação', 
                        keySub: 'destns', 
                        key: 'codtns',
                        prevDataSearch: { lismod: 'COO' },
                    hasButtonCreate: false,
                        }) : 
                        () => {}
                    }
                    disabled={
                      checkPrevCompanyValue.exists ? false : true
                    }
                    >
                    <SearchIcon />
                    </IconButton>
                ),
                }}
            />
            
            <TextField
                label="Fornecedor"
                onClick={
                () => checkPrevCompanyValue.exists ? 
                    handleOpenDialogSearch({
                    id: 'fornecedor', 
                    title: 'Fornecedor', 
                    subKeySub: 'cgccpf', 
                    keySub: 'nomfor', 
                    key: 'codfor',
                    prevDataSearch: {},
                    hasButtonCreate: true,
                    }) 
                    : () => {}
                }
                value={
                    checkPrevCompanyValue.exists ?
                        handleReturnValue('fornecedor', fields)
                    : 'Selecione uma empresa primeiro'
                }
                fullWidth
                className={classes.textField}
                disabled={
                  checkPrevCompanyValue.exists ? false : true
                }
                InputProps={{
                endAdornment: (
                    <IconButton
                    className={classes.searchIcon}
                    onClick={() => checkPrevCompanyValue.exists ? 
                        handleOpenDialogSearch({
                        id: 'fornecedor', 
                        title: 'Fornecedor', 
                        keySub: 'nomfor', 
                        key: 'codfor',
                        prevDataSearch: {},
                    hasButtonCreate: true,
                        }) : 
                        () => {}
                    }
                    disabled={
                        checkPrevCompanyValue.exists ? false : true
                    }
                    >
                    <SearchIcon />
                    </IconButton>
                ),
                }}
            />

            <TextField
                label="Condição de Pagamento"
                onClick={
                () => checkPrevCompanyValue.exists ? 
                    handleOpenDialogSearch({
                    id: 'condPgto', 
                    title: 'Condição de Pagamento', 
                    keySub: 'descpg', 
                    key: 'codcpg',
                    prevDataSearch: {},
                    hasButtonCreate: false,
                    }) 
                    : () => {}
                }
                value={
                    checkPrevCompanyValue.exists ?
                        handleReturnValue('condPgto', fields)
                    : 'Selecione uma empresa primeiro'
                }
                fullWidth
                className={classes.textField}
                disabled={
                  checkPrevCompanyValue.exists ? false : true
                }
                InputProps={{
                endAdornment: (
                    <IconButton
                    className={classes.searchIcon}
                    onClick={() => checkPrevCompanyValue.exists ? 
                        handleOpenDialogSearch({
                        id: 'condPgto', 
                        title: 'Condição de Pagamento', 
                        keySub: 'descpg', 
                        key: 'codcpg',
                        prevDataSearch: {},
                    hasButtonCreate: false,
                        }) : 
                        () => {}
                    }
                    disabled={
                      checkPrevCompanyValue.exists ? false : true
                    }
                    >
                    <SearchIcon />
                    </IconButton>
                ),
                }}
            />
            <TextField
              label="Observação"
              type="text"
              value={fields.find(f => f.id === 'obs')?.value || ''}
              className={classes.textField}
              onChange={e => {
                  const upd = [...fields];
                  upd[upd.findIndex(f => f.id === 'obs')].value = e.target.value;
                  setFields(upd);
              }}
              fullWidth
            />
          </Grid>
        </TabPanel>

        {/* ------------ PRODUTOS --------------- */}
        <TabPanel value={tab} index={1}>
          <Grid container spacing={2} style={{ padding: 8, marginTop: 16, gap: 16 }}>
            {
              openItemDrawer.open &&
                <PurchaseOrderEmitItemDialog
                  handleClose={handleCloseItemDrawer}
                  fieldsInit={openItemDrawer.item}
                  handleUpdateValue={(itens) => {
                    handleCheckFieldsItem(itens)
                  }}
                  isDialogOpen={openItemDrawer.open}
                  checkPrevCompanyValue={checkPrevCompanyValue}
                  checkPrevBranchValue={checkPrevBranchValue}
                />
            }
            <Button
              variant="outlined"
              component="span"
              className={classes.backgroundColor}
              onClick={() => handleOpenItemDrawer(fieldsInit, -1)}
            >
              Adicionar item
            </Button>
            {
              fields.find(f => f.id === 'itens').value.map((item: any, index: number) => {
                const tipo = item.find((value: any) => value.id === 'tipo')?.value.tipo;

                let value = item.find((value: any) => value.id === 'produto')?.value?.codpro;
                let description = item.find((value: any) => value.id === 'produto')?.value?.despro;
                if (tipo === 'servico') {
                  value = item.find((value: any) => value.id === 'servico')?.value.codser;
                  description = item.find((value: any) => value.id === 'servico')?.value.desser;
                }

                return (
                  <Grid key={index} container spacing={2} alignItems="center" style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 8, marginBottom: 16 }}>
                    {/* Título */}
                    <Grid item xs={12} sm={6}>
                      <Typography variant="h6" className={classes.title}>
                        {tipo === 'servico' ? 'Serviço' : 'Produto'}
                      </Typography>
                      <Typography variant="h6" className={classes.title}>
                        {value}
                      </Typography>
                      <Typography variant="h6" className={classes.title}>
                        {description}
                      </Typography>
                    </Grid>

                    {/* Botões de ação */}
                    <Grid item xs={12} sm={6} container justifyContent="flex-end" spacing={1}>
                      <Grid item>
                        <Button
                          variant="outlined"
                          onClick={() => handleOpenItemDrawer(item, index)}
                        >
                          Editar
                        </Button>
                      </Grid>
                      <Grid item>
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={() => {
                            const upd = [...fields];
                            const itensForm = upd[upd.findIndex(f => f.id === 'itens')];
                            const values = itensForm.value.filter((_: any, i: number) => i !== index);
                            itensForm.value = values;
                            setFields(upd);
                          }}
                        >
                          Remover
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )
              })
            }
          </Grid>
        </TabPanel>

        {/* ------------ Parcelas --------------- */}
        <TabPanel value={tab} index={2}>
          <Grid container spacing={2} style={{ padding: 8, marginTop: 16, gap: 16 }}>
            {
              openParcelaDrawer.open &&
                <PurchaseOrderEmitParcelaDialog
                  handleClose={handleCloseParcelaDrawer}
                  fieldsInit={JSON.parse(JSON.stringify(openParcelaDrawer.item))}
                  handleUpdateValue={(itens) => {
                    handleCheckFieldsParcela(itens)
                  }}
                  isDialogOpen={openParcelaDrawer.open}
                />
            }
            <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', }}>
              <Typography >Tem parcelas especiais: </Typography>
              <RadioGroup
                row
                style={{ marginLeft: 8 }}
                value={isPagamentoVista ? 'nao' : 'sim'}
                onChange={(e) => {
                  const isVista = e.target.value === 'nao';
                  setIsPagamentoVista(isVista);
                  if (isVista) {
                    handleCheckFieldsParcelaEmpty();
                  }
                }}
              >
                {/* <FormControlLabel
                  value="nao"
                  control={<Radio size="small" />}
                  label="Não"
                /> */}
                <FormControlLabel
                  value="sim"
                  control={<Radio size="small" />}
                  label="Sim"
                />
              </RadioGroup>
            </Box>
            {
              !isPagamentoVista &&
              <>
                <Button
                  variant="outlined"
                  component="span"
                  className={classes.backgroundColor}
                  style={{
                    marginTop: 20,
                  }}
                  onClick={() => {
                    const qtd = fields.find(f => f.id === 'parcelas').value?.length + 1;
                    const upd = [...fieldsInitParcela];
                    upd[upd.findIndex(f => f.id === 'seqpar')].value.seqpar = qtd;
                    handleOpenParcelaDrawer(upd, qtd)
                  }}
                >
                  Adicionar parcela
                </Button>
                {
                  fields.find(f => f.id === 'parcelas').value.map((item: any) => {
                    let data = item.find((value: any) => value.id === 'vctpar')?.value?.vctpar;
                    let valor = item.find((value: any) => value.id === 'vlrpar')?.value?.vlrpar;
                    let seqpar = item.find((value: any) => value.id === 'seqpar')?.value?.seqpar;

                    return (
                      <Grid key={seqpar} container spacing={2} alignItems="center" style={{ padding: 16, border: '1px solid #e0e0e0', borderRadius: 8, marginBottom: 16 }}>
                        {/* Título */}
                        <Grid item xs={12} sm={6}>
                          <Typography variant="h6" className={classes.title}>
                            Parcela {seqpar}
                          </Typography>
                          <Typography variant="h6" className={classes.title}>
                            Data: { formatedYearDate(data) }
                          </Typography>
                          <Typography variant="h6" className={classes.title}>
                            Valor: { valor.toFixed(2).replace('.',',')}
                          </Typography>
                        </Grid>

                        {/* Botões de ação */}
                        <Grid item xs={12} sm={6} container justifyContent="flex-end" spacing={1}>
                          <Grid item>
                            <Button
                              variant="outlined"
                              onClick={() => handleOpenParcelaDrawer(item, seqpar)}
                            >
                              Editar
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              variant="contained"
                              color="secondary"
                              onClick={() => {
                                const upd = [...fields];
                                const itensForm = upd[upd.findIndex(f => f.id === 'parcelas')];
                                const values = itensForm.value.filter((_: any, i: number) => i !== seqpar - 1);
                                itensForm.value = values;
                                setFields(upd);
                              }}
                            >
                              Remover
                            </Button>
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  })
                }
              </>
            }
          </Grid>
        </TabPanel>

        {/* ------------ ANEXOS --------------- */}
        <TabPanel value={tab} index={3}>
          <Grid container spacing={2} style={{ padding: 8, marginTop: 16, gap: 16 }}>
            <input
              type="file"
              multiple
              style={{ display: 'none' }}
              id="upload-attachments"
              onChange={e => {
                const newFiles = Array.from(e.target.files ?? []);
                const updatedFields = [...fields];
                const arquivosIndex = updatedFields.findIndex(f => f.id === 'arquivos');
                const prevArquivos = updatedFields[arquivosIndex]?.value?.arquivos ?? [];

                // Adiciona sem duplicar nomes
                const arquivosAtualizados = [
                  ...prevArquivos,
                  ...newFiles.filter(nf => !prevArquivos.some((pf:any) => pf.name === nf.name)),
                ];

                updatedFields[arquivosIndex].value = { arquivos: arquivosAtualizados };
                setFields(updatedFields);

                // Reset para poder selecionar o mesmo arquivo de novo se quiser
                e.target.value = '';
              }}
            />
            <label htmlFor="upload-attachments">
              <Button variant="outlined" component="span" className={classes.backgroundColor}>
                Selecionar arquivos
              </Button>
            </label>
            <Box mt={2} width="100%">
              {(fields.find(f => f.id === 'arquivos')?.value?.arquivos || []).map((file: File, idx: number) => (
                <Grid
                  key={idx}
                  container
                  alignItems="center"
                  spacing={1}
                  style={{ marginBottom: 8 }}
                >
                  {/* Link clicável para visualizar */}
                  <Grid item xs>
                    <Typography
                      variant="body2"
                      component="span"
                      style={{ textDecoration: 'underline', cursor: 'pointer' }}
                      onClick={() => {
                        const url = URL.createObjectURL(file);
                        window.open(url, '_blank');
                        setTimeout(() => URL.revokeObjectURL(url), 1000);
                      }}
                    >
                      {file.name}
                    </Typography>
                  </Grid>

                  {/* Botão de remover */}
                  <Grid item>
                    <Button
                      size="small"
                      color="secondary"
                      variant="outlined"
                      onClick={() => {
                        const updatedFields = [...fields];
                        const arquivosIndex = updatedFields.findIndex(f => f.id === 'arquivos');
                        const arquivos = updatedFields[arquivosIndex]?.value?.arquivos ?? [];
                        arquivos.splice(idx, 1);
                        updatedFields[arquivosIndex].value = { arquivos };
                        setFields(updatedFields);
                      }}
                    >
                      Remover
                    </Button>
                  </Grid>
                </Grid>
              ))}
            </Box>
          </Grid>
        </TabPanel>
      </div>

      {/* -------- FOOTER -------- */}
      <div className={classes.drawerFooterBox}>
        {
          fields.find(f => f.id === 'itens').value.length > 0 &&
          <Box style={{ width: '100%' }}>
            <Typography>Total de itens: {fields.find(f => f.id === 'itens').value.length}</Typography>
            <Typography>Valor total: {(fields.find(f => f.id === 'itens').value.map((item:any) => {
              const valor = item.find((value: any) => value.id === 'valorunitario')?.value.valorunitario;
              const qtd = item.find((value: any) => value.id === 'qtd')?.value.qtd;
              return valor * qtd
            }).reduce((acc: number, item:any) => acc + item, 0)).toFixed(2).replace('.',',')}</Typography>
          </Box>
        }
        <Box className={classes.drawerFooter}>
        <Button onClick={handleCloseDrawer} className={classes.backBackgroundColor} style={{ marginRight: 20 }}>
          Cancelar
        </Button>
        <Button onClick={handleCheckFields} className={classes.backgroundColor}>
          {isDrawerOpen.btnTitle}
        </Button>
        </Box>
      </div>
    </Drawer>
  );
}